import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { BANK_ACCOUNT_STATE } from './useBankAccountWithCodeValidation.types.ts';
import {
	confirmBankAccount as confirmBankAccountRequest,
	deleteShareholderBankAccount,
	requestBankAccountCode as requestBankAccountCodeRequest,
	upsertBankAccount,
} from '@dealstack/frontend/shared/dataExchange/services/shareholder/investor.service.ts';

export const useBankAccountWithCodeValidation = () => {
	const [magicCode, setMagicCode] = useState('');
	const [magicCodeError, setMagicCodeError] = useState('');
	const [pageMode, setPageMode] = useState(BANK_ACCOUNT_STATE.FORM);
	const [pendingBankAccountId, setPendingBankAccountId] = useState<string | null>(null);

	const { mutate: requestBankAccountCode, isPending: requestBankAccountCodeLoading } =
		useMutation({
			mutationFn: (variables: Parameters<typeof requestBankAccountCodeRequest>[0]) =>
				requestBankAccountCodeRequest(variables),
		});
	const { mutateAsync: confirmBankAccount, isPending: confirmBankAccountLoading } = useMutation({
		mutationFn: (variables: Parameters<typeof confirmBankAccountRequest>[0]) =>
			confirmBankAccountRequest(variables),
	});
	const { mutate: upsertBankAccountRequest, isPending: upsertBankAccountRequestLoading } =
		useMutation({
			mutationFn: (variables: Parameters<typeof upsertBankAccount>[0]) =>
				upsertBankAccount(variables),
		});

	const {
		mutate: deleteBankAccountRequest,
		isPending: deleteBankAccountLoading,
		isSuccess: deleteBankAccountSuccess,
		reset: resetDeleteBankAccount,
	} = useMutation({
		mutationFn: (variables: Parameters<typeof deleteShareholderBankAccount>[0]) =>
			deleteShareholderBankAccount(variables),
	});

	return {
		magicCode,
		setMagicCode,
		magicCodeError,
		setMagicCodeError,
		pageMode,
		setPageMode,
		pendingBankAccountId,
		setPendingBankAccountId,
		requestBankAccountCode,
		requestBankAccountCodeLoading,
		confirmBankAccount,
		confirmBankAccountLoading,
		upsertBankAccountRequest,
		upsertBankAccountRequestLoading,
		deleteBankAccountRequest,
		deleteBankAccountLoading,
		deleteBankAccountSuccess,
		resetDeleteBankAccount,
	};
};
